import React from "react";
import { CheckBox } from "devextreme-react/check-box";
import "./style.scss";

export default function Payment({ payment = {} }) {
  const {
    AccountNo,
    BankName,
    OriginalBeneficiary,
    PasswordToOpenPayslip,
    BankBranch,
    IsBankTransfer,
    IsReceivePayslipByEmail,
  } = payment;

  return (
    <React.Fragment>
      <div className="form-readonly ma-2">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Account No</div>
            <div className="form-value">
              <span>{AccountNo}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Original Beneficiary</div>
            <div className="form-value">
              <span>{OriginalBeneficiary}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Password To Open Payslip</div>
            <div className="form-value">
              <span>{PasswordToOpenPayslip}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Bank Name</div>
            <div className="form-value">
              <span>{BankName}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Bank Branch</div>
            <div className="form-value">
              <span>{BankBranch}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <CheckBox
            defaultValue={IsBankTransfer}
            readOnly={true}
            text="Is Bank Transfer"
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={IsReceivePayslipByEmail}
            readOnly={true}
            text="Is Receive Payslip By Email"
          />
          <br />
          <br />
        </div>
      </div>
    </React.Fragment>
  );
}
